import { type SVGProps } from "react"

export function Connector5(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={124}
            height={207}
            fill="none"
            {...props}
        >
            <path
                fill="azure"
                fillRule="evenodd"
                d="M122 0a2 2 0 0 1 2 2v5.97a2 2 0 1 1-4 0V2a2 2 0 0 1 2-2m0 13.93a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0V15.93a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0V35.83a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0V55.73a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0V75.63a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0V95.53a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0v-11.94a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0v-11.94a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0v-11.94a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2v11.94a2 2 0 1 1-4 0v-11.94a2 2 0 0 1 2-2m0 19.9a2 2 0 0 1 2 2V203h-7.88a2 2 0 1 1 0-4H120v-3.97a2 2 0 0 1 2-2M22 201a2 2 0 0 1 2-2h5.88a2 2 0 1 1 0 4H24a2 2 0 0 1-2-2m13.72 0a2 2 0 0 1 2-2h11.76a2 2 0 1 1 0 4H37.72a2 2 0 0 1-2-2m19.6 0a2 2 0 0 1 2-2h11.76a2 2 0 1 1 0 4H57.32a2 2 0 0 1-2-2m19.6 0a2 2 0 0 1 2-2h11.76a2 2 0 1 1 0 4H76.92a2 2 0 0 1-2-2m19.6 0a2 2 0 0 1 2-2h11.76a2 2 0 1 1 0 4H96.52a2 2 0 0 1-2-2"
                clipRule="evenodd"
            />
            <circle
                cx={6}
                cy={201}
                r={6}
                fill="#FF2FFB"
            />
        </svg>
    )
}
